export default __webpack_public_path__ + "static/media/pic6.884974e2.jpg";